import { Navigate, useLocation } from 'react-router-dom';

import PageLoader from '../component/loader/PageLoader';

import { useAuth } from '../hooks/useAuth';

import AppNavigationProvider from '../provider/AppNavigationProvider';

const ProtectedRoute = ({ children }) => {
  const { user, authReady } = useAuth();
  const location = useLocation();

  if (!authReady) {
    return <PageLoader loading={true} />;
  }

  if (!user || user.isAnonymous) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <AppNavigationProvider>{children}</AppNavigationProvider>;
};

export default ProtectedRoute;
